import CustomPaginationComponent from "@/components/common/custom-pagination-component";
import { SearchBar } from "@/components/common/search-bar";
import { ContentLayout } from "@/components/common/content-layout";
import { XIcon } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { useState } from "react";
import useInvoices from "@/features/invoices/hooks/use-invoice";
import { InvoiceCard } from "@/features/invoices/ui/invoice-card";
import { InvoiceFilters } from "@/features/invoices/ui/invoice-filters";

export default function Invoices() {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "0", 10);
  const search = searchParams.get("search") || "";

  const [selectedInvoiceId, setSelectedInvoiceId] = useState<string | null>(
    null,
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const filterParts: string[] = [];
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const status = searchParams.get("status");

  if (startDate) filterParts.push(`start_date::${startDate}`);
  if (endDate) filterParts.push(`end_date::${endDate}`);
  if (status && status !== "all") filterParts.push(`status::${status}`);

  const filter = filterParts.join(",");

  const { data, error, isFetching, isLoading } = useInvoices({
    page,
    search,
    filter,
  });

  const invoices = data?.invoices || [];
  const currentPage = data?.page || 0;
  const lastPage = data ? data.lastPage + 1 : 0;

  const handlePageChange = (newPage: number) => {
    if (newPage >= 0 && newPage < lastPage) {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("page", newPage.toString());
      setSearchParams(newParams);
    }
  };

  return (
    <div className="w-full">
      {/* Search & Filters */}
      <div className="bg-white p-4 rounded-lg mb-4">
        <div className="flex flex-wrap items-center gap-3">
          <InvoiceFilters />

          <div className="flex-1 min-w-[200px]">
            <SearchBar
              placeholder="Search Invoices"
              urlParamStrategy="prefix"
              clearButton={{
                enabled: true,
                position: "inside",
                ariaLabel: "Clear search",
                icon: <XIcon className="w-4 h-4" />,
              }}
              fieldSelector={{
                enabled: false,
                fields: [],
              }}
              className="w-full"
            />
          </div>
        </div>
      </div>

      <ContentLayout
        header={null}
        data={invoices}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        errorMessage="Failed to load invoices"
        emptyState={{
          message: "No invoices found",
        }}
      >
        {invoices.map((invoice: any) => (
          <InvoiceCard
            key={invoice.id}
            invoice={invoice}
            onCardClick={() => {
              setSelectedInvoiceId(invoice.id);
              setIsDrawerOpen(true);
            }}
          />
        ))}

        {invoices.length > 0 && (
          <CustomPaginationComponent
            currentPage={currentPage}
            lastPage={lastPage}
            onPageChange={handlePageChange}
          />
        )}
      </ContentLayout>
    </div>
  );
}
